import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CalendarClockIcon, DownloadIcon, UserPlusIcon } from 'lucide-react';
import { highValueActions } from '../data/abbviePro';
const iconMap = {
  register: UserPlusIcon,
  download: DownloadIcon,
  meeting: CalendarClockIcon
};
export function HighValueActionsScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-white px-6 py-20" aria-labelledby="hva-title" data-id="element-200" data-mp="zubvvcg0my5r">
      <div className="mx-auto w-full max-w-6xl" data-id="element-201" data-mp="uuz2s9yjwuuq">
        <p className="mb-4 text-sm font-semibold text-primary" data-id="element-202" data-mp="uwadktqez2vc">07 - High-value action optimisation</p>
        <h2 id="hva-title" className="max-w-2xl text-4xl font-bold leading-tight text-secondary md:text-6xl" data-id="element-203" data-mp="q2peszgzy4v3">
          Guide momentum toward the actions that matter
        </h2>
        <p className="mt-5 max-w-2xl text-lg text-slate-500" data-id="element-204" data-mp="1imnym0al01gf">Snaks are designed to carry narrative momentum into the specific conversions AbbVie Pro needs.</p>

        <div className="mt-14 grid gap-4 sm:grid-cols-3" data-id="element-205" data-mp="34923l3hhh23n">
          {highValueActions.map((item, index) => {
          const Icon = iconMap[item.icon as keyof typeof iconMap];
          return <motion.div key={item.action} initial={reduceMotion ? false : {
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.22,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="rounded-2xl bg-presentation-canvas p-6" data-id="element-206" data-mp="2ukai9e6xhg1p" data-mpi={index}>
                <Icon className="h-6 w-6 text-abbvie-cyan" aria-hidden="true" data-id="element-207" data-mp="2blg4a7fagjml" />
                <h3 className="mt-4 font-bold text-abbvie-navy" data-id="element-208" data-mp="2gjram86dkc02">{item.action}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-500" data-id="element-209" data-mp="2gluadjxbxjhz">{item.detail}</p>
              </motion.div>;
        })}
        </div>

        <div className="mt-14 rounded-2xl border border-slate-200 p-6 sm:p-8" data-id="element-210" data-mp="erbhjiygyfrs">
          <p className="mb-6 text-xs font-bold uppercase tracking-wide text-slate-400" data-id="element-211" data-mp="dbqze08i4ea5">Illustrative comparison</p>
          <div className="space-y-5" data-id="element-212" data-mp="8bcmo4vygg5s">
            <div data-id="element-213" data-mp="8eh1rxaykwb8">
              <div className="mb-2 flex items-center justify-between text-sm font-semibold text-slate-500" data-id="element-214" data-mp="3db91zhat91p">
                <span data-id="element-215" data-mp="3ujufl2g3qcu7">Manual browsing</span>
                <span data-id="element-216" data-mp="3ul5il01q3gk9">Higher drop-off</span>
              </div>
              <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-100" data-id="element-217" data-mp="w2i24ixzh6fk">
                <div className="h-full w-2/5 rounded-full bg-slate-300" data-id="element-218" data-mp="r35jybi24njb" />
              </div>
            </div>
            <div data-id="element-219" data-mp="mbnf3ccwy2t2">
              <div className="mb-2 flex items-center justify-between text-sm font-semibold text-abbvie-navy" data-id="element-220" data-mp="mb3z416tpoho">
                <span data-id="element-221" data-mp="hcavr1l93dv8">Narrative-guided episodes</span>
                <span className="text-abbvie-pro" data-id="element-222" data-mp="1es6k7bgqksdi">Higher completion</span>
              </div>
              <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-100" data-id="element-223" data-mp="1a1q75sgtv8ro">
                <div className="h-full w-4/5 rounded-full bg-abbvie-cyan" data-id="element-224" data-mp="19zwvtzv9s0dc" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}